import {Button, Modal, Spinner} from "react-bootstrap";
import React from 'react';
import {useState} from "react";

export default function DeleteVmaModal(props) {
    const [isDeletingInProgress,setIsDeletingInProgress] = useState(false);

    const handleOk = async () => {
        setIsDeletingInProgress(true);
        await props.deleteVma(props.selectedVmaRow.uuid);
        setIsDeletingInProgress(false);
    }

    const handleCancel = () => {
        props.setShow(false);
    }

    return (
        <Modal dialogClassName="filter-modal" show={props.show} onHide={() =>{
            if(!isDeletingInProgress){
                props.setShow(false);
            }
        }} style={{marginTop: '10%', left: '1%'}}>
            <Modal.Header closeButton>
                <Modal.Title>Delete VMA</Modal.Title>
            </Modal.Header>
            <Modal.Body>
               Are you sure you want to delete the VMA?
            </Modal.Body>
            <Modal.Footer>
                {
                    isDeletingInProgress ?
                        <Button disabled variant="primary">
                            <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className='mr-1'
                            />
                            Deleting...
                        </Button>
                        :
                        <Button style={{width: 80}} onClick={()=>handleOk()} variant="primary">OK</Button>
                }
                <Button disabled={isDeletingInProgress} style={{width: 80}} onClick={()=>handleCancel()}  variant="primary" >Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}
